import { defineMessages } from 'react-intl';
export default defineMessages({
  MineVipCardApplicationcheckedWaiting: {
    id: 'MineVipCardApplication.checkedWaiting',
    defaultMessage: '验证完毕，请稍后……',
  },
  MineVipBlackCardApplicationNull: {
    id: 'MineVipBlackCardApplication.Null',
    defaultMessage: '暂无',
  },
  MineVipBlackCardApplicationlevelUpToGetPrivilege: {
    id: 'MineVipBlackCardApplication.levelUpToGetPrivilege',
    defaultMessage: '升级到下一等级可享受特权',
  },
  MineVipBlackCardApplicationVIPGrade: {
    id: 'MineVipBlackCardApplication.VIPGrade',
    defaultMessage: '会员等级',
  },
  MineVipBlackCardApplicationshowVIPRules: {
    id: 'MineVipBlackCardApplication.showVIPRules',
    defaultMessage: '查看会员等级体系 >',
  },
  MineVipBlackCardApplicationcurrentPrivilege: {
    id: 'MineVipBlackCardApplication.currentPrivilege',
    defaultMessage: '当前等级享受特权',
  },
  MobileCheckInApplicationsignInSuccess: {
    id: 'MobileCheckInApplication.signInSuccess',
    defaultMessage: '签到成功',
  },
  MobileCheckInApplicationkryBriefing: {
    id: 'MobileCheckInApplication.kryBriefing',
    defaultMessage: '客如云新品发布会',
  },
  ModifyBindPhoneApplicationcurrentPN: {
    id: 'ModifyBindPhoneApplication.currentPN',
    defaultMessage: '当前手机号:',
  },
  ModifyBindPhoneApplicationmodifyPNPrompt: {
    id: 'ModifyBindPhoneApplication.modifyPNPrompt',
    defaultMessage: '修改手机号后，会员余额、会员积分等所有顾客信息将转移到新的手机号',
  },
  ModifyBindPhoneApplicationmodifyPNPrompt1: {
    id: 'ModifyBindPhoneApplication.modifyPNPrompt1',
    defaultMessage: '修改手机号后，会员余额、捞币等所有顾客信息将转移到新的手机号',
  },
  ModifyBindPhoneApplicationPNModified: {
    id: 'ModifyBindPhoneApplication.PNModified',
    defaultMessage: '您已将绑定手机号修改为',
  },
  ModifyBindPhoneApplicationnuknownPN: {
    id: 'ModifyBindPhoneApplication.nuknownPN',
    defaultMessage: '未知的电话号码',
  },
  OrderApplicationdiscountInfo: {
    id: 'OrderApplication.discountInfo',
    defaultMessage: '折扣商品每单限购1份，超出部分按原价购买',
  },
  OrderApplicationverifyCode: {
    id: 'OrderApplication.verifyCode',
    defaultMessage: '验证码',
  },
  OrderApplicationarrivedTime: {
    id: 'OrderApplication.arrivedTime',
    defaultMessage: '送达时间',
  },
  OrderApplicationarrivedShopTime: {
    id: 'OrderApplication.arrivedShopTime',
    defaultMessage: '到店时间',
  },
  OrderApplicationpayWays: {
    id: 'OrderApplication.payWays',
    defaultMessage: '支付方式',
  },
  OrderApplicationpayWaysOnline: {
    id: 'OrderApplication.payWaysOnline',
    defaultMessage: '在线支付',
  },
  OrderApplicationpayWaysAfterPay: {
    id: 'OrderApplication.payWaysAfterPay',
    defaultMessage: '货到付款',
  },
  OrderApplicationgetFoodTime: {
    id: 'OrderApplication.getFoodTime',
    defaultMessage: '取餐时间',
  },
  OrderApplicationgetFoodNow: {
    id: 'OrderApplication.getFoodNow',
    defaultMessage: '现在，完成支付后立即取餐',
  },
  OrderApplicationgetFoodLater: {
    id: 'OrderApplication.getFoodLater',
    defaultMessage: '稍后，预约今天',
  },
  OrderApplicationgetFoodLaterTime: {
    id: 'OrderApplication.getFoodLaterTime',
    defaultMessage: '取餐',
  },
  OrderApplicationchooseAddress: {
    id: 'OrderApplication.chooseAddress',
    defaultMessage: '选择收货地址',
  },
  OrderApplicationunBindAddressPrompt: {
    id: 'OrderApplication.unBindAddressPrompt',
    defaultMessage: '您还没有添加地址唷～',
  },
  OrderApplicationoutFor: {
    id: 'OrderApplication.outFor',
    defaultMessage: '外送',
  },
  OrderApplicationSelfGet: {
    id: 'OrderApplication.SelfGet',
    defaultMessage: '自提',
  },
  OrderApplicationselfGetAddress: {
    id: 'OrderApplication.selfGetAddress',
    defaultMessage: '自取地址',
  },
  OrderApplicationshowMap: {
    id: 'OrderApplication.showMap',
    defaultMessage: '查看地图',
  },
  OrderApplicationConnection: {
    id: 'OrderApplication.Connection',
    defaultMessage: '联系方式',
  },
  OrderDetailUncheckApplicationTransaction: {
    id: 'OrderDetailUncheckApplication.Transaction',
    defaultMessage: '流水号',
  },
  OrderDinnerStateMentApplicationloginToGetPrivilege: {
    id: 'OrderDinnerStateMentApplication.loginToGetPrivilege',
    defaultMessage: '尚未登录，登录后立享会员权益！',
  },
  OrderDinnerStateMentApplicationgotoLogin: {
    id: 'OrderDinnerStateMentApplication.gotoLogin',
    defaultMessage: '去登录',
  },
  OrderApplicationSelfGetError: {
    id: 'OrderApplication.SelfGetError',
    defaultMessage: '您选择的取餐信息不完全，请填写',
  },
  OrderApplicationNoAddress: {
    id: 'OrderApplication.NoAddress',
    defaultMessage: '所选的配送地址无收货地址，请选择',
  },
  OrderApplicationNoAddressInfo: {
    id: 'OrderApplication.NoAddressInfo',
    defaultMessage: '所选的配送地址信息不合规，请修改',
  },
  OrderApplicationInputCorrectConnect: {
    id: 'OrderApplication.InputCorrectConnect',
    defaultMessage: '请填写正确的联系方式',
  },
  OrderApplicationInputConnectPN: {
    id: 'OrderApplication.InputConnectPN',
    defaultMessage: '请填写提货人联系电话',
  },
  OrderApplicationInputConnectName: {
    id: 'OrderApplication.InputConnectName',
    defaultMessage: '请填写联系人姓名(非必填)',
  },
  OrderApplicationTableware: {
    id: 'OrderApplication.Tableware',
    defaultMessage: '餐具数量',
  },
  HighLevelMember: {
    id: 'HighLevelMember',
    defaultMessage: '恭喜您已是我们的最高等级会员',
  },
  stillToUpgrade: {
    id: 'stillToUpgrade',
    defaultMessage: '还差{nextLevelDIff}个{numUnit}升级为{levelName}',
  },
  backToMyCenter: {
    id: 'ModifyBindPhoneApplication.backToMeCenter',
    defaultMessage: '返回个人中心',
  },
  noSelectTime: {
    id: 'noSelectTime',
    defaultMessage: '没有可用的时间选择...',
  },
  ShopApplicationLocationFailedRefresh: {
    id: 'ShopApplication.LocationFailedRefresh',
    defaultMessage: '定位失败，请刷新重试',
  },
  ShopApplicationLocationFailed: {
    id: 'ShopApplication.LocationFailed',
    defaultMessage: '定位失败',
  },
  ShopApplicationLocationFailedSelect: {
    id: 'ShopApplication.LocationFailedSelect',
    defaultMessage: '定位失败，请手动选择地址',
  },
  mineVipLevelCount: {
    id: 'mineVipLevelCount',
    defaultMessage: '个',
  },
  mineVipLevelStar: {
    id: 'mineVipLevelStar',
    defaultMessage: '海星',
  },
  OrderApplicationPredict: {
    id: 'OrderApplication.predict',
    defaultMessage: '预计',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/container/part4/index.js